export const AuPlaceholdersColorsList = [
	'#3276f5',
	'#4a8ff6',
	'#5cb5ff',
	'#97e031',
	'#feae36',
	'#918bff',
	'#4653cc',
	'#ea68ae',
	'#cf4d7c',
	'#cf4d7c',
];
